module.exports = __webpack_public_path__ + "static/media/icon_menu_transform_disabled.f1624512.svg";